import React from "react";
import PaymentMethods from "../components/sections/PaymentMethods";
import { useI18n } from "../i18n/I18nProvider";

export default function IntegrationsPage() {
  const { t } = useI18n();
  return (
    <div data-testid="integrations-page">
      <section className="py-24 sm:py-32 border-b border-zinc-200">
        <div className="container-oj">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">{t("payments_page.eyebrow")}</div>
          <h1 className="font-display mt-4 text-5xl sm:text-7xl font-black tracking-tighter leading-[0.92] text-oj-ink max-w-3xl">
            {t("payments_page.h1")}
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-zinc-600">
            {t("payments_page.intro_a")} <a href="https://swisspayout.com" target="_blank" rel="noreferrer" className="font-semibold text-oj-ink underline underline-offset-4 decoration-2 decoration-oj-payment">swisspayout.com</a>.
          </p>
        </div>
      </section>
      <PaymentMethods />
    </div>
  );
}
